export default __webpack_public_path__ + "static/media/cowboy-cafe.a1903027.png";